<template>
    <b-card id="edicaoItensLoteLicitacao" class="mx-2 mx-md-5" bg-variant="light" no-body>
        <template #header>
            <header-sagres titulo="Itens do lote" :botoes="botoesHeader" />
        </template>
        <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
            <b-form @submit.prevent="handleSubmit(salvar)">
                <b-table :fields="fieldsItens" :items="itensLote" :busy="tableBusyItens" :current-page="currentPageItens"
                    hover no-border-collapse striped small sort-by="" stacked="xl" responsive show-empty>
                    <template #empty>
                        <span>Não foram encontrados dados.</span>
                    </template>
                    <template #emptyfiltered>
                        <span>Não foram encontrados dados.</span>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-dark">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong class="loading-text">Carregando...</strong>
                        </div>
                    </template>
                    <template #cell(DeItemMatServ)="data">
                        <table-form-validation-provider v-if="data.item.modoEdicao" :hasLabel="false" v-slot="defaultState" rules="max:4000">
                            <b-form-input :disabled="data.item.loading" v-model="data.item.novaDeItemMatServ"
                                :state="defaultState.state" />
                        </table-form-validation-provider>
                        <span v-else>{{ data.value }}</span>
                    </template>
                    <template #cell(QtItemMatServ)="data">
                        <table-form-validation-provider v-if="data.item.modoEdicao" :hasLabel="false" v-slot="defaultState">
                            <b-form-input :disabled="data.item.loading" v-model="data.item.novaQtde" v-bind="licitaQtdProps"
                                :state="defaultState.state" />
                        </table-form-validation-provider>
                        <span v-else>{{ data.value }}</span>
                    </template>
                    <template #cell(DeUnidadeMedida)="data">
                        <table-form-validation-provider v-if="data.item.modoEdicao" :hasLabel="false" v-slot="defaultState" rules="max:100">
                            <b-form-input :disabled="data.item.loading" v-model="data.item.novaUn"
                                :state="defaultState.state" />
                        </table-form-validation-provider>
                        <span v-else>{{ data.value }}</span>
                    </template>
                    <template #cell(VlUnitarioEstimado)="data">
                        <table-form-validation-provider v-if="data.item.modoEdicao" :hasLabel="false" v-slot="defaultState">
                            <money class="form-control" :disabled="data.item.loading" v-model="data.item.novoValorUnit"
                                v-bind="vMoney4CasasOptions" :state="defaultState.state" />
                        </table-form-validation-provider>
                        <span v-else>{{ data.value }}</span>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-overlay v-if="row.item.modoEdicao" :show="row.item.loading" variant="transparent" opacity="0.8"
                            blur="1px">
                            <div class="actions-icons">
                                <b-button type="submit" variant="link" class="text-dark py-0 px-2"
                                    :disabled="!row.item.isPreenchido()">
                                    <font-awesome-icon icon="save" />
                                    <div style="font-size: 12px">Salvar</div>
                                </b-button>
                                <b-link class="text-dark" @click="pararEdicaoItemLote(row.item)">
                                    <font-awesome-icon icon="cancel" />
                                    <div style="font-size: 12px">Cancelar {{ row.item.IdItemLoteLicitacao ? 'edição' : '' }}
                                    </div>
                                </b-link>
                            </div>
                        </b-overlay>
                        <div v-else class="actions-icons">
                            <b-link class="text-dark" @click="editarItemLoteLicitacao(row.item)">
                                <font-awesome-icon icon="edit" />
                                <div style="font-size: 12px">Editar item</div>
                            </b-link>
                            <btn-excluir :idItem="row.item" :excluirItem="removerItemLoteLicitacao" />
                        </div>
                    </template>
                </b-table>
            </b-form>
        </validation-observer>
        <table-pagination v-if="totalRowsItens > pageSize" :total-rows="totalRowsItens" :per-page="pageSize"
            class="ml-3 mb-1" :firstCurrentPg="currentPageItens" @pageChange="pageChange" />
    </b-card>
</template>

<script lang="ts">
import TablePagination from "@/components/atos-pessoal/TablePagination.vue"
import HeaderSagres from "@/components/shared/HeaderSagres.vue"
import TableFormValidationProvider from '@/components/shared/TableFormValidationProvider.vue'
import BtnExcluir from '@/components/shared/btn-excluir.vue'
import ldiService from '@/services/licitacoes/ldiService'
import { BotaoSagres } from "@/types/botao-sagres"
import { Decimal32dot4Props } from '@/types/form-default-props'
import { fieldEdicaoItemLicitacao, fieldsEditarItensLoteLicitacao } from '@/types/licitacoes/ldi/fields-item-licitacao'
import { ItemLicitacao } from '@/types/licitacoes/ldi/item-licitacao'
import { TableField } from '@/types/table-field'
import { UtilsTS } from '@/utilsts'
import { Money } from 'v-money'
import { ValidationObserver } from "vee-validate"
import { mixins } from 'vue-class-component'
import { Component, Vue } from 'vue-property-decorator'

const CompProps = Vue.extend({
    name: 'EditarItensLoteLicitacao',
    components: { BtnExcluir, HeaderSagres, Money, TableFormValidationProvider, TablePagination, ValidationObserver },
    props: {
        idLote: {
            type: Number,
            required: true
        },
        ro: {
            type: Boolean,
            default: false
        }
    }
})

@Component
export default class EditarItensLoteLicitacao extends mixins(UtilsTS, CompProps) {
    licitaQtdProps = Decimal32dot4Props
    fieldsItens: TableField[] = [...fieldsEditarItensLoteLicitacao, ...(!this.ro ? [fieldEdicaoItemLicitacao] : [])]
    itensLote: ItemLicitacao[] = []

    pageSize = 5

    currentPageItens = 1
    totalRowsItens = 0
    tableBusyItens = false
    botoesHeader: BotaoSagres[] = this.ro ? [] : [{
        id: 1,
        icone: 'plus',
        texto: 'Adicionar Item',
        acao: this.criarNovoItemLote,
    }]

    get existeEdicaoItem() {
        return this.itensLote.some(lo => lo.modoEdicao)
    }

    async mounted() {
        this.loadData()
    }

    async loadData() {
        try {
            this.tableBusyItens = true
            const response = await ldiService.buscarItensLote(this.idLote, this.currentPageItens, this.pageSize)

            if (response) {
                this.itensLote = response.itensLote.map(l => {
                    const item = Object.assign(new ItemLicitacao(), l)
                    return item
                })
                this.totalRowsItens = response.totalRows
                //console.log('load data itensLote: ', this.itensLote)
            } else {
                this.$toast.error('Erro ao consultar os itens do lote desta licitação.');
            }
        } finally {
            this.tableBusyItens = false;
        }
    }
    async pageChange(value) {
        this.currentPageItens = value;
        await this.loadData();
    }
    async editarItemLoteLicitacao(value: ItemLicitacao) {
        const meuItemLote = this.itensLote.find(lo => lo.IdItemLoteLicitacao === value.IdItemLoteLicitacao)
        if (meuItemLote) {
            meuItemLote.modoEdicao = true
            meuItemLote.novaDeItemMatServ = meuItemLote.novaDeItemMatServ || meuItemLote.DeItemMatServ
            meuItemLote.novaUn = meuItemLote.novaUn || meuItemLote.DeUnidadeMedida
            meuItemLote.novoValorUnit = meuItemLote.novoValorUnit || meuItemLote.VlUnitarioEstimado
            meuItemLote.novaQtde = meuItemLote.novaQtde || meuItemLote.QtItemMatServ
        }
    }
    pararEdicaoItemLote(itemLote: ItemLicitacao) {
        //console.log("id do item lote: ", itemLote.IdItemLoteLicitacao)

        if (itemLote.IdItemLoteLicitacao) {
            const meuItemLote = this.itensLote.find(lo => lo.IdItemLoteLicitacao === itemLote.IdItemLoteLicitacao)
            if (meuItemLote) {
                meuItemLote.modoEdicao = false
            }
        } else {
            //console.log(itemLote, itemLote.IdItemLoteLicitacao)
            this.itensLote = this.itensLote.filter(l => l.IdItemLoteLicitacao !== undefined)
            this.$emit('input', this.itensLote);
        }
    }
    async salvar() {
        const loteEmEdicao = this.itensLote.find(lo => lo.modoEdicao)
        try {
            if (!loteEmEdicao) return this.$toast.error('Lote não encontrado, por favor atualize a página.')
            loteEmEdicao.loading = true
            const loteEditado = new ItemLicitacao(loteEmEdicao)
            loteEditado.DeItemMatServ = loteEmEdicao.novaDeItemMatServ
            loteEditado.DeUnidadeMedida = loteEmEdicao.novaUn
            loteEditado.VlUnitarioEstimado = loteEmEdicao.novoValorUnit
            loteEditado.QtItemMatServ = loteEmEdicao.novaQtde

            const retorno = await ldiService.adicionarItemLote(loteEditado)
            this.itensLote = this.itensLote.filter(l => l.IdItemLoteLicitacao !== loteEmEdicao.IdItemLoteLicitacao)
            this.itensLote.unshift(retorno)
            this.$toast.success(`O item ${retorno.DeItemMatServ} foi atualizado.`)
            this.$emit('loteAtualizado');
        } catch (e: any) {
            this.tratarError(e)
            if (loteEmEdicao) loteEmEdicao.loading = false
        }
    }
    async removerItemLoteLicitacao(itemLote: ItemLicitacao) {
        //console.log('Remover item do lote: ', itemLote)
        try {
            const retorno = await ldiService.removerItemLote(itemLote.IdItemLoteLicitacao)
            if (retorno) {
                this.itensLote = this.itensLote.filter(p => p.IdItemLoteLicitacao !== itemLote.IdItemLoteLicitacao)
                this.$emit('input', this.itensLote);
                this.$toast.success(`O item ${itemLote.DeItemMatServ} foi removido deste lote.`)
                this.$emit('loteAtualizado');
            }
            else this.$toast.error(`Falha ao remover o item ${itemLote.DeItemMatServ}.`)
        } catch (e: any) {
            this.tratarError(e)
        }
    }

    /**
     * Limpa a tela e abre o formulário de novo lote
     */
    async criarNovoItemLote() {
        if (this.existeEdicaoItem) return;
        //ir para última página
        await this.pageChange(Math.floor(this.totalRowsItens / this.pageSize) + 1)
        //criar lote vazio, colocar no final do array
        const novoItemLote = new ItemLicitacao()
        novoItemLote.modoEdicao = true
        novoItemLote.IdLoteLicitacao = this.idLote
        //tá faltando colocar o sequencialote aqui
        this.itensLote.push(novoItemLote)
        this.$emit('input', this.itensLote);
    }
}


</script>

<style scoped>
a.disabled {
    pointer-events: none;
    color: gray !important;
}
</style>